const HorizontalLine = ({ margin = 16, width = 100, color = '#d5d7dc' }) => {
  return (
    <div
      style={{
        margin: `${margin}px auto`,
        width: `${width}%`,
        borderBottom: `1px solid ${color}`,
      }}
    ></div>
  );
};

export default HorizontalLine;
